import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { H5, Image } from "../../../../../AbstractElements";
import { useSelector } from "react-redux";

const ServiceTitle = () => {
  const serviceDetail = useSelector((state) => state.services.serviceDetail);
  return (
    <Fragment>
      <Row>
        <Col sm="8">
          <div className="media">
            <div className="media-body align-self-center">
              <H5 attrH5={{ className: "mt-0 user-name" }}>
                {serviceDetail.name}
              </H5>
            </div>
          </div>
        </Col>
        <Col sm="4" className="align-self-center">
          <div className="float-sm-end">
            Created At: <small>{serviceDetail.created_at?.split("T")[0]}</small>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ServiceTitle;
